import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';

let firstRender = false
const CauseOfProduct = inject("authenStore")(observer((props) => {
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])
  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log("getMasterData : ", err)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title="ข้อมูลเหตุผลเพิ่มลดสินค้า"
    tableConfig={{
      key: "item_reason_id",
      apiPath: "item_reason/list",
      allowDelete: {
        visible: false,
        key: "group_id",
        apiPath: "prodgroup/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: "ลำดับ",
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'item_reason_type_name',
          caption: "ประเภท",
          allowFiltering: true
        },
        {
          dataField: 'item_reason_name',
          caption: "เหตุผล",
          allowFiltering: false
        },
        {
          dataField: 'status_name',
          caption: "สถานะ",
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: "แก้ไขโดย"
        }
      ],
      exportExcel: {
        fileName: 'ข้อมูลเหตุผลเพิ่มลดสินค้า',
        columnConfig: [
          { label: 'ลำดับ', value: 'no' },
          { label: 'ประเภท', value: 'item_reason_type_name' },
          { label: 'เหตุผล', value: 'item_reason_name' },
          { label: 'สถานะ', value: 'status_name' },
          { label: 'แก้ไขโดย', value: 'updated_by' }
        ]
      }
    }}
    formData={{
      item_reason_type: "",
      item_reason_name: "",
      status: "Y"
    }}
    modalConfig={{
      screenName: "item_reason",
      visible: true,
      title: "เหตุผลเพิ่มลดสินค้า",
      required: ["item_reason_type", "item_reason_name"],
      fieldTypeNumber: [],
      paramName: "item_reason_id",
      apiPath: {
        "get": '',
        "post": 'item_reason/add',
        "put": 'item_reason/update'
      },
      elements: [
        {
          fieldName: "item_reason_type",
          label: "ประเภท",
          placeholder: "ประเภท",
          inputType: "select",
          required: true,
          defaultValue: "",
          options: [
            {
              label: "เพิ่ม",
              value: 1
            },
            {
              label: "ลด",
              value: 2
            }
          ]
        },
        {
          fieldName: "item_reason_name",
          label: "เหตุผล",
          placeholder: "เหตุผล",
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: "สถานะ",
          inputType: "select",
          required: true,
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default CauseOfProduct